import { UserState } from "./usersTypes";

export const initialState: UserState = {
  users: [],
  loading: false,
  error: undefined,
};
